import { postJSON } from '@/utils/http';
import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';
import { useAuth } from '../auth';

const PermissionsContext = createContext();

function PermissionsProvider ({ children }) {
  // whatever you set here as default, will be used in both server side and client as well
  const [providerData, setProviderData] = useState({
    ready: false,
    data: {
      // add default data to your provider here
    }
  });

  const { data:userData } = useAuth();

  // you can get extra data asynchronously if needed
  // this will only affect the client side
  async function fetchProviderData () {
    const { data, error } = await postJSON('api/user/permissions', {});
    if (error) {
      console.error('Failed retrieving user permissions', error);
      return;
    }

    setProviderData({
      ...providerData,
      data: { orgs: data },
      ready: true,
    });
  }

  useEffect(() => {
    if (userData.access_token) {
      fetchProviderData();
    }
  }, [userData.access_token]);
  const value = {
    ...providerData,
    setData (key, value) {
      setProviderData({
        ...providerData,
        data: {
          ...providerData.data,
          [key]: value
        }
      });
    },
    async refresh () {
      return await fetchProviderData();
    },
    findByTenantId (tenantId) {
      const orgs = Object.values(providerData?.data?.orgs || {});
      let found = null;
      orgs.find(org => {
        return Object.values(org.products).find(product => {
          const tenant = product.tenants[tenantId];
          if (tenant) {
            // found it
            found = {
              org,
              product,
              tenant
            };
            return true;
          }
          return false;
        });
      });
      return found;
    }
    // TODO: add more methods/actions here
  };

  return (
    <PermissionsContext.Provider value={value}>

      {children}

      {/*
        //! you can add extra components here
       */}
    </PermissionsContext.Provider>
  );
}

// this allows you to use it as a simpler hook
function usePermissions () {
  const context = useContext(PermissionsContext);
  if (context === undefined) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }

  return context;
}

export {
  PermissionsProvider,
  PermissionsContext,
  usePermissions
};
